// extracted by mini-css-extract-plugin
module.exports = {"input":"InputPhone_input__19ncH","labelEffect":"InputPhone_labelEffect__2oDqV","iconInput":"InputPhone_iconInput__7UrUh","iconError":"InputPhone_iconError__HI518"};